import TablaConciliacion from "../../../TablaConciliacion";

function TablaPanamericana() {
  return <TablaConciliacion nombreUseCase="panamericana" titulo="PANAMERICANA" />;
}

export default TablaPanamericana;
